import { PairingState } from '../../installation/api'

export const getDeviceIsPaired = (pairingState: PairingState | null): boolean => {
  return pairingState === 'paired'
}
